/**
 * this is onboarding status, don't check permissions or url
 * If onboarding status is not completed, redirect user to the state url.
 */
import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router'
import { map, mergeMap, Observable, of } from 'rxjs'
import { routes } from '../app/app.routes'
import { CustomerService } from '../service/customer.service'
import { OnboardingService } from '../service/onboarding.service'
import { Onboarding, OnboardingProgressState } from '../gql/generated'

const STATE_URL = {
  REGISTER: '/register',
  INFORMATION_FULFILL: '/register-complete',
  SMS_VERIFITION: '/verify'
}

@Injectable({
  providedIn: 'root',
})
export class OnboardingGuard implements CanActivate {
  constructor(
    private router: Router,
    private onboardingService: OnboardingService,
    private customerService: CustomerService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.customerService.getActiveCustomer().pipe(
      mergeMap((activeCustomerResp) => {
        // get login status
        const activeCustomer = activeCustomerResp?.data?.activeCustomer
        if (!activeCustomer) {
            this.router.navigate(['/register'], {
              queryParams: {
                resolveUrl: state.url,
              },
            })
            return of(false)
        } else {
            return this.onboardingService.getOnboarding(activeCustomer.id).pipe(
              map((response) => {
                const onboarding = response.data.getOnboarding;
                if(onboarding?.state === OnboardingProgressState.COMPLETED){
                  return true
                }else{
                  this.router.navigate([this.getStateUrl(onboarding)])
                  return false
                }
              })
            )
          }
      })
    )
  }

  getStateUrl(onboarding: any){
    if(onboarding?.state === OnboardingProgressState.INFORMATION_FULFILL){
      return STATE_URL.INFORMATION_FULFILL
    }else if(onboarding?.state === OnboardingProgressState.SMS_VERIFICATION){
      return STATE_URL.SMS_VERIFITION
    }else{
      // this case should not occur
      return STATE_URL.REGISTER
    }
  }
}
